/* eslint no-shadow: ["error", { "allow": ["BodyMagicIcons"] }] */

enum BodyMagicIcons {
  Star = 'star',
  StarWithStand = 'star-with-stand',
}

export default BodyMagicIcons;
